// extracted by mini-css-extract-plugin
module.exports = {"articleSection":"ArticleSection_articleSection__MZAcE"};